import { BasePage } from '@/components/ui/base-page'
import { Outlet, useOutletContext } from 'react-router-dom'
import { BreadcrumbItem } from '@/components/ui/breadcrumb-nav'
import { useSoftwareContext } from '@/pages/software/SoftwarePage'

type DarDenOutletContextType = {
  parentBreadcrumbs: BreadcrumbItem[]
}

export function DarDenAppsPage() {
  const { parentBreadcrumbs } = useSoftwareContext()

  const breadcrumbs: BreadcrumbItem[] = [
    ...parentBreadcrumbs,
    {
      label: "DarDen Apps",
      description: "Applications developed by DarDen",
      href: "/software/darden"
    }
  ]

  return (
    <BasePage
      breadcrumbs={breadcrumbs}
    >
      <div className="container mx-auto">
        <Outlet context={{ parentBreadcrumbs: breadcrumbs }} />
      </div>
    </BasePage>
  )
}

export function useDarDenContext() {
  return useOutletContext<DarDenOutletContextType>()
}